<template>
    <div>
        <h2>IATSE LOCAL 667 CONSTITUTION AND BYLAWS</h2>
        <div class="tw-text-xl tw-py-4">The IATSE 667 Constitution and Bylaws govern all official activities of the Union/Local, its officers and members.
        </div>

        <a href="/pdf/CB Revision 8.28.23  Final approved 667.pdf" target="_blank" class="text-link tw-underline">View Constitution and Bylaws</a>
        <div class="tw-my-6">
            <h2>Policy</h2>
            <h4 class="tw-mb-2 tw-mt-2">Privacy Policy</h4>
            <a href="/pdf/PIPEDA-and-PRIVACY-POLICY-2023.pdf" target="_blank" class="text-link tw-underline">View Privacy Policy</a>
            <h4 class="tw-mb-2 tw-mt-4">Medical Leave Policy</h4>
            <a href="/pdf/Medical-Leave-Policy-2023.pdf" target="_blank" class="text-link tw-underline">View Medical Policy</a>
        </div>

    </div>

</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";

    export default {
        name: "GovernanceIndex",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        props: {
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
        mounted () {
            //
        },
        methods:{
            //
        },
    }
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
}
</style>
